// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"e0f326bf","191":"3fe97dac","358":"2612cef4","453":"8367c910","683":"f89f8553","797":"a6cb1a24","813":"4b0acf18","822":"9fee6e2c","840":"f456cc4d"}[chunkId] + ".chunk.js";
};